export var Policy;
(function (Policy) {
    let type;
    (function (type) {
        type["POLICY"] = "Policy";
    })(type = Policy.type || (Policy.type = {}));
})(Policy || (Policy = {}));
